// src/utils/timezonePreference.js

export const TIMEZONE_STORAGE_KEY =
  "app.timezone";

const FALLBACK_TIMEZONES = [
  "Europe/Lisbon",
  "Europe/London",
  "Europe/Madrid",
  "Europe/Paris",
  "Europe/Brussels",
  "Europe/Amsterdam",
  "Europe/Berlin",
  "Europe/Rome",
  "Europe/Zurich",
  "Europe/Vienna",
  "Europe/Prague",
  "Europe/Warsaw",
  "Europe/Copenhagen",
  "Europe/Stockholm",
  "Europe/Oslo",
  "Europe/Helsinki",
  "Europe/Dublin",
  "Europe/Athens",
  "Europe/Bucharest",
  "Europe/Sofia",
  "Europe/Istanbul",
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "America/Sao_Paulo",
  "Asia/Dubai",
  "Asia/Singapore",
  "Asia/Tokyo",
  "Australia/Sydney",
];

export const getBrowserTimezone =
  () => {
    try {
      return (
        Intl.DateTimeFormat()
          .resolvedOptions()
          .timeZone ||
        "Europe/Lisbon"
      );
    } catch {
      return "Europe/Lisbon";
    }
  };

export const getStoredTimezone =
  () =>
    localStorage.getItem(
      TIMEZONE_STORAGE_KEY
    ) ||
    getBrowserTimezone();

export const saveTimezone =
  (
    timezone
  ) => {
    if (
      !timezone
    ) {
      return;
    }

    localStorage.setItem(
      TIMEZONE_STORAGE_KEY,
      timezone
    );

    window.dispatchEvent(
      new CustomEvent(
        "app:timezone:changed",
        {
          detail: {
            timezone,
          },
        }
      )
    );
  };

export const getTimezoneOptions =
  () => {
    let zones =
      FALLBACK_TIMEZONES;

    try {
      if (
        typeof Intl
          .supportedValuesOf ===
        "function"
      ) {
        zones =
          Intl.supportedValuesOf(
            "timeZone"
          );
      }
    } catch {
      zones =
        FALLBACK_TIMEZONES;
    }

    const current =
      getStoredTimezone();

    return Array.from(
      new Set([
        current,
        ...zones,
      ])
    );
  };

/*
 * Usa esta função nos locais da app onde
 * queremos respeitar o fuso horário escolhido
 * pelo utilizador.
 */
export const formatAppDateTime =
  (
    value,
    {
      locale =
        document.documentElement
          .lang ||
        "pt-PT",

      timezone =
        getStoredTimezone(),

      dateStyle =
        "short",

      timeStyle =
        "short",
    } = {}
  ) => {
    if (
      !value
    ) {
      return "";
    }

    const date =
      value instanceof
      Date
        ? value
        : new Date(
            value
          );

    if (
      Number.isNaN(
        date.getTime()
      )
    ) {
      return "";
    }

    return new Intl.DateTimeFormat(
      locale,
      {
        timeZone:
          timezone,

        dateStyle,

        timeStyle,
      }
    ).format(
      date
    );
  };